import {fabric} from "fabric";
import {ShowPageScopeCollector} from "@frontend/group/modules/scope-collectors/show-page-collector";
const getScopePage = () => ShowPageScopeCollector.get([
  'canvas_data',
  'updateLayoutChanges',
  'selectedObjects',
  'reorderObjectCanvas',
]);

export function getPointOfObject (obj) {
  return obj.getPointByOrigin('left', 'top');
}

export function setObjectPosition(obj, x, y) {
  obj.setPositionByOrigin(new fabric.Point(parseInt(x), parseInt(y)), 'left', 'top');
}

export function deleteBaseLayer() {
  const {canvas, templateField} = this;

  if (!canvas) {
    return;
  }

  const {
    canvas_data,
    updateLayoutChanges,
    reorderObjectCanvas,
  } = getScopePage();
  const preview = window.previews.find(preview => preview.id === canvas.instance_id);

  if (!templateField || !preview) {
    canvas.remove(this);
    canvas.requestRenderAll();
    return;
  }

  const deletedLayersArray = [...(preview.data?.deleted_layers ?? [])];
  if (!deletedLayersArray.includes(templateField.id)) {
    deletedLayersArray.push(templateField.id);
  }

  preview.data.deleted_layers = deletedLayersArray;

  const changeHandler = this.updateLayoutChanges || updateLayoutChanges;
  changeHandler(canvas.instance_id, 'deleted_layers', deletedLayersArray);

  preview.template.fields = preview.template.fields.filter(field => field.id !== templateField.id);
  if (canvas_data?.[canvas.instance_id]?.templateInstance?.fields) {
    canvas_data[canvas.instance_id].templateInstance.fields = canvas_data[canvas.instance_id].templateInstance.fields
      .filter(field => field.id !== templateField.id);
  }

  canvas.remove(this);
  canvas.requestRenderAll();
  reorderObjectCanvas(preview.canvas);
}

export function deleteTextLayer() {
  deleteBaseLayer.call(this);
}
